export { triggerSearch } from './triggerSearch';
